<template>
    <home-cloud />
</template>

<script>
import HomeCloud from './homeCloud.vue'

export default {
    name: 'HomeCloudPreviewEntry',
    components: {
        HomeCloud
    }
}
</script>
